import { ComponentProps, FC } from "react";

type TIconProps = ComponentProps<'svg'> & {
    size?: number;
}

const iconProps = (size: number): ComponentProps<'svg'> => ({
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
})

const strokeProps = {
    stroke: 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
} as const

const withIconProps = (Icon: FC<TIconProps>): FC<TIconProps> => {
    return ({size = 20, ...props}) => <Icon size={size} {...props} />
}

export const CalendarIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <rect x="4" y="5" width="16" height="15" rx="3" {...strokeProps} />
        <path d="M8 3V7" {...strokeProps} />
        <path d="M16 3V7" {...strokeProps} />
        <path d="M4 10H20" {...strokeProps} />
        <path d="M8 14H8.01" {...strokeProps} />
        <path d="M12 14H12.01" {...strokeProps} />
        <path d="M16 14H16.01" {...strokeProps} />
        <path d="M8 17H8.01" {...strokeProps} />
        <path d="M12 17H12.01" {...strokeProps} />
        <path d="M16 17H16.01" {...strokeProps} />
    </svg>
))

export const ClockIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <circle cx="12" cy="12" r="8" {...strokeProps} />
        <path d="M12 7.5V12L15 14" {...strokeProps} />
    </svg>
))

export const TelegramIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M20 5L4 11.5L10.5 13.5L13.5 19L20 5Z" {...strokeProps} />
        <path d="M10.5 13.5L14 10.5" {...strokeProps} />
    </svg>
))

export const TutorIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M12 4L20 8L12 12L4 8L12 4Z" {...strokeProps} />
        <path d="M7 10.5V15.5C7 17.433 9.239 19 12 19C14.761 19 17 17.433 17 15.5V10.5" {...strokeProps} />
        <path d="M20 8V14" {...strokeProps} />
    </svg>
))

export const StudentIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M12 12C14.209 12 16 10.209 16 8C16 5.791 14.209 4 12 4C9.791 4 8 5.791 8 8C8 10.209 9.791 12 12 12Z" {...strokeProps} />
        <path d="M5 20C5.829 16.85 8.59 14.75 12 14.75C15.41 14.75 18.171 16.85 19 20" {...strokeProps} />
        <path d="M9.5 8.2H9.51" {...strokeProps} />
        <path d="M14.5 8.2H14.51" {...strokeProps} />
    </svg>
))

export const CheckIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M5 12.5L9.5 17L19 7" {...strokeProps} />
    </svg>
))

export const BanIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <circle cx="12" cy="12" r="8" {...strokeProps} />
        <path d="M7 7L17 17" {...strokeProps} />
    </svg>
))

export const RescheduleIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M7 8H16.5C18.433 8 20 9.567 20 11.5C20 13.433 18.433 15 16.5 15H14" {...strokeProps} />
        <path d="M10 5L7 8L10 11" {...strokeProps} />
        <path d="M17 19H7.5C5.567 19 4 17.433 4 15.5C4 13.567 5.567 12 7.5 12H10" {...strokeProps} />
        <path d="M14 16L17 19L14 22" {...strokeProps} />
    </svg>
))

export const TrashIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M5 7H19" {...strokeProps} />
        <path d="M10 11V17" {...strokeProps} />
        <path d="M14 11V17" {...strokeProps} />
        <path d="M8 7L8.5 20H15.5L16 7" {...strokeProps} />
        <path d="M9.5 7V4H14.5V7" {...strokeProps} />
    </svg>
))

export const EditIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M4 20H8L18.5 9.5C19.604 8.396 19.604 6.604 18.5 5.5C17.396 4.396 15.604 4.396 14.5 5.5L4 16V20Z" {...strokeProps} />
        <path d="M13.5 6.5L17.5 10.5" {...strokeProps} />
    </svg>
))

export const HistoryIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M5 7V12H10" {...strokeProps} />
        <path d="M5.5 12C5.5 15.59 8.41 18.5 12 18.5C15.59 18.5 18.5 15.59 18.5 12C18.5 8.41 15.59 5.5 12 5.5C9.872 5.5 7.983 6.523 6.798 8.105" {...strokeProps} />
        <path d="M12 8.5V12L14.5 13.5" {...strokeProps} />
    </svg>
))

export const InfoIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <circle cx="12" cy="12" r="8" {...strokeProps} />
        <path d="M12 11V16" {...strokeProps} />
        <path d="M12 8H12.01" {...strokeProps} />
    </svg>
))

export const FilterIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M4 6H20" {...strokeProps} />
        <path d="M7 12H17" {...strokeProps} />
        <path d="M10 18H14" {...strokeProps} />
    </svg>
))
export const ArrowLeftIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M15 6L9 12L15 18" {...strokeProps} />
    </svg>
))

export const LongArrowLeftIcon = withIconProps(({size = 20, ...props}) => (
    <svg {...iconProps(size)} {...props}>
        <path d="M19 12H5" {...strokeProps} />
        <path d="M12 19L5 12L12 5" {...strokeProps} />
    </svg>
))
